export default "__VITE_ASSET__B3cVl6YW__"